module.exports = __webpack_public_path__ + "img/Chris Blackshear.042778eb.jpg";